<template>
  <PTooltip
    label="Dupliquer le parapheur"
    :offset="5"
    :delay="500"
    activatorWrapperClasses="h-full flex items-center justify-center"
  >
    <PButton
      @click="open"
      data-sentry-id="CloneLetterFileBtn"
      mode="tertiary"
      class="h-full w-full"
      aria-label="Dupliquer le parapheur"
    >
      <p>Dupliquer</p>
    </PButton>
    <CloneModal :letter-file="letterFile" v-model="isOpen"></CloneModal>
  </PTooltip>
</template>

<script setup lang="ts">
import { PTooltip, PButton } from "@pasta/box-v2";
import { useLetterFileStore } from "../../../stores/letter-file.store";
import { computed, ref } from "vue";
import CloneModal from "../../../components/CloneModal.vue";
import { useNavigationChecker } from "../../../composable/navigation-checker";

const letterFileStore = useLetterFileStore();
const letterFile = computed(() => letterFileStore.getCurrent());
const isOpen = ref<boolean>(false);

const navigationChecker = useNavigationChecker();
function open() {
  navigationChecker.check();
  isOpen.value = true;
}
</script>
